import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux'
import { addCartItem, decreaseCartItem, removeCartItem, clearCart } from '../store/cartReducer';
import { useSelector } from 'react-redux'
import useBlockChainData from "../helpers/blockChainData";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PurchaseModal from '../components/PurchaseModal';
import { Link,useNavigate } from 'react-router-dom';

import axios from 'axios';
const Cart = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const cartItems = useSelector((state) => state.cartItems);
    const userData = useSelector((state)=> state.login);
    let apiUrl = '/';

    if(process.env.REACT_APP_ENVIRONMENT == 'local'){
         apiUrl = process.env.REACT_APP_SERVER_API_URL;
    }
    const { purchaseProduct } = useBlockChainData();
    const totalPrice = cartItems.reduce((total, item) => {
        return parseInt(total) + parseInt(item.price) * item.quantity;
    }, 0);
    const [isLoading, setIsLoading] = useState(false);

    const [showModal,setShowModal] = useState(false);
    const incrementCount = (item) => {
        const updatedItem = { ...item, quantity: item.quantity + 1 };
        dispatch(addCartItem(updatedItem));
    }
    const decrementCount = (item) => {
        dispatch(decreaseCartItem(item.productId));
    }

    const handlePurchaseProduct = async () => {

        try {
            const purchaseResponse = await purchaseProduct(cartItems, userData);
            if (purchaseResponse.status.toString()) {
                dispatch(clearCart());
                setShowModal(true);
                storeResponseInDB(purchaseResponse);
                navigate('/thankyou');
            }
        } catch (error) {
            console.error("Error during purchase:", error);
            toast.error("An error occurred during the purchase process.");
        }
    };

    const storeResponseInDB = (response) => {
        if(response.status.toString()){
            const translateData = translateResponse(response);
            console.log("translateData",translateData);
            try {
                const postorder = axios.post(`${apiUrl}api/orders/storeorder`,translateData);
                console.log("postorder",postorder);
            } catch (error) {
                console.error('Error:', error);
            }
        }
        
    }

    const translateResponse = (response) => {

        const {returnValues} = response.events.TransactionRecorded;
        const data = {
            orderNumber:response.blockNumber.toString(),
            transactionId:returnValues.transactionId.toString(),
            productIds:returnValues.productIds,
            productNames:returnValues.productNames,
            totalPrice:returnValues.totalPrice.toString(),
            userId:returnValues.userId,
            userName:returnValues.userName,
            buyerAddress:returnValues.buyer,
            sellerAddress:returnValues.seller,
            blockHash:response.blockHash,
            transactionHash:response.transactionHash,
            timestamp:returnValues.timestamp.toString(),
            items:response.items,
            basePrice:response.basePrice
        }

        return data;
    }

    const handleRemoveItems = (productId) => {
        setIsLoading(true);
        dispatch(removeCartItem(productId));

        setTimeout(() => {
            setIsLoading(false);
            toast.success("Item removed to cart successfully!");
        }, 100);
    }

    const handleRemoveAllItems = () => {
        dispatch(clearCart());
        toast.success("All items removed from the cart!");
    };

    useEffect(() => {
        if (cartItems.length === 0 && showModal === false) {
            const timer = setTimeout(() => {
                navigate('/');
            }, 200); 

            return () => clearTimeout(timer); 
        }
    }, [cartItems, showModal]);
    return (
        <div className="cart-section" style={{marginTop:"50px",marginBottom:"50px"}}>

            <div className="container">
                <div className="row">
                    <h1>Shopping Cart</h1>
                    <div className="col-lg-8 col-md-12">

                        <div className="cart-table-wrap">
                            <table className="cart-table">
                                <thead className="cart-table-head">
                                    <tr className="table-head-row">
                                        <th className="product-remove"></th>
                                        <th className="product-image">Product Image</th>
                                        <th className="product-name">Name</th>
                                        <th className="product-price">Price</th>
                                        <th className="product-quantity">Quantity</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    { console.log("cartItems",cartItems)}
                                    {
                                       
                                        cartItems.map((item, id) => {
                                            return (<tr className="table-body-row">
                                                <td className="product-remove"><a href="#" onClick={() => { handleRemoveItems(item.productId) }}><i className="far fa-window-close"></i></a></td>

                                                <td className="product-image"><img
                                                    src={`${item.imageId}`}
                                                    width="80"
                                                    alt="..."
                                                /></td>
                                                <td className="product-name">{item.name}</td>
                                                <td className="product-price">{item.price} Eth</td>
                                                <td>
                                                    <div className="input-group input-group-sm mw-140">
                                                        <button
                                                            className="btn btn-primary text-white"
                                                            type="button"
                                                            onClick={() => { decrementCount(item) }}
                                                        >
                                                            <i className="bi bi-dash-lg"></i>
                                                        </button>

                                                        <div className="form-control">{item.quantity}</div>
                                                        <button
                                                            className="btn btn-primary text-white"
                                                            type="button"
                                                            onClick={() => { incrementCount(item) }}
                                                        >
                                                            <i className="bi bi-plus-lg"></i>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>)
                                        })
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="total-section">
                            <table className="total-table">
                                <thead className="total-table-head">
                                    <tr className="table-total-row">
                                        <th>Total</th>
                                        <th>Price</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    <tr className="total-data">
                                        <td><strong>Total: </strong></td>
                                        <td>{totalPrice} Eth</td>
                                    </tr>
                                </tbody>
                            </table>
                            <div className="cart-buttons">
                                <Link className="boxed-btn black" onClick={() => handlePurchaseProduct()}>Place Order </Link>
                                <button type="button" class="cart-btn btn btn-danger" onClick={handleRemoveAllItems}> Remove All</button>
                            </div>
                        </div>
                    </div>
                    {showModal && <PurchaseModal showModal={showModal} setShowModal={setShowModal} />}
                </div>
            </div>
        </div>
    )
}

export default Cart
